import { useState } from 'react';

interface FAQItem {
  question: string;
  answer: string;
}

const faqItems: FAQItem[] = [
  {
    question: '国产在线观看需要下载APP吗？',
    answer: '不需要。国产在线观看支持即点即播，无需下载任何软件或APP，直接在浏览器中即可流畅观看所有影视内容。',
  },
  {
    question: '国产在线观看支持哪些设备观看？',
    answer: '国产在线观看全面支持电脑、平板、手机等多种设备观看。无论您使用Windows、Mac、iOS还是Android系统，都能获得一致的流畅观影体验。',
  },
  {
    question: '国产在线观看的资源更新频率如何？',
    answer: '我们每日更新最新的国产电视剧、电影、综艺和动漫资源。热门剧集通常在播出后24小时内上线，确保您能第一时间观看到最新内容。',
  },
  {
    question: '国产在线观看的影视资源画质如何？',
    answer: '平台提供高清乃至超清画质的影视资源，支持自适应码率技术，根据您的网络状况自动调整播放质量，确保流畅的观看体验。',
  },
  {
    question: '国产在线观看是否收费？',
    answer: '国产在线观看目前为免费平台，所有影视资源均可免费在线观看，无需会员注册，无需任何费用。',
  },
  {
    question: '如何搜索想看的国产电视剧或电影？',
    answer: '您可以使用网站顶部的搜索功能，输入影视名称即可快速找到相关内容。同时您也可以通过分类导航浏览不同类型的影视资源。',
  },
];

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  return (
    <section className="px-4 md:px-6 py-10 md:py-14 bg-background-100/70">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-8">
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950 mb-2" style={{ fontFamily: 'var(--font-heading)' }}>
            常见问题
          </h2>
          <p className="text-sm text-foreground-600">关于国产在线观看的常见疑问解答</p>
        </div>

        <div className="space-y-3">
          {faqItems.map((item, index) => (
            <div
              key={index}
              className="rounded-xl border border-background-200/70 bg-background-50 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between px-5 py-4 text-left hover:bg-background-100/50 transition-colors cursor-pointer"
                aria-expanded={openIndex === index}
              >
                <span className="text-sm font-semibold text-foreground-950 pr-4">{item.question}</span>
                <i
                  className={`ri-arrow-down-s-line text-foreground-500 w-5 h-5 flex items-center justify-center transition-transform duration-300 shrink-0 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                ></i>
              </button>
              {openIndex === index && (
                <div className="px-5 pb-4">
                  <p className="text-sm text-foreground-600 leading-relaxed">{item.answer}</p>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>

      {/* FAQPage Schema */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'FAQPage',
            mainEntity: faqItems.map((item) => ({
              '@type': 'Question',
              name: item.question,
              acceptedAnswer: {
                '@type': 'Answer',
                text: item.answer,
              },
            })),
          }),
        }}
      />
    </section>
  );
}